import React from "react";
import styled from "styled-components";
import { FaCity, FaCarSide, FaClock } from "react-icons/fa";

const services = [
  {
    icon: <FaCity />,
    title: "City Rides",
    desc: "Effortless travel within the city. Fast, reliable, and comfortable.",
    color: "#054752", // Primary
  },
  {
    icon: <FaCarSide />,
    title: "Outstation",
    desc: "Seamless intercity journeys. Explore new destinations with ease.",
    color: "#00796b", // Teal scale
  },
  {
    icon: <FaClock />,
    title: "Rentals",
    desc: "Flexible hourly packages. Your car, your schedule.",
    color: "#004d40", // Darker teal
  },
];

const ServiceHighlights = () => {
  return (
    <SectionContainer>
      <SectionTitle>Our Premium Services</SectionTitle>
      <CardsGrid>
        {services.map((service, index) => (
          <GlassCard key={index} glowColor={service.color}>
            <IconWrapper color={service.color}>{service.icon}</IconWrapper>
            <CardTitle>{service.title}</CardTitle>
            <CardDesc>{service.desc}</CardDesc>
            <LearnMoreBtn color={service.color}>
              Learn More <span>&rarr;</span>
            </LearnMoreBtn>
          </GlassCard>
        ))}
      </CardsGrid>
    </SectionContainer>
  );
};

export default ServiceHighlights;

const SectionContainer = styled.section`
  padding: 5rem 2rem;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: #054752;
  margin-bottom: 3rem;
  font-weight: 700;
  text-align: center;
  position: relative;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 2rem;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 1.6rem;
  }

  &::after {
    content: "";
    display: block;
    width: 60px;
    height: 4px;
    background: #054752;
    margin: 10px auto 0;
    border-radius: 2px;
  }
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1200px;

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
  }
`;

const GlassCard = styled.div`
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border-color: ${(props) => props.glowColor};
  }
`;

const IconWrapper = styled.div`
  font-size: 2.5rem;
  color: ${(props) => props.color};
  margin-bottom: 1.5rem;
  background: ${(props) => props.color}10;
  padding: 1rem;
  border-radius: 16px;
`;

const CardTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #054752;
  margin-bottom: 0.75rem;
`;

const CardDesc = styled.p`
  color: #556c70;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const LearnMoreBtn = styled.button`
  background: transparent;
  border: none;
  color: ${(props) => props.color};
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  transition: gap 0.2s ease;

  span {
    transition: transform 0.2s ease;
  }

  &:hover {
    gap: 0.8rem;
    
    span {
      transform: translateX(2px);
    }
  }
`;
